import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { IconArrowRight } from '@redteclab/icons'

import { Link } from 'base-ui'

import { getStoryblokHrefLink } from '../../getStoryblokHrefLink'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokImageCardType } from '../../model/storyblokTypes.generated'
import { StoryblokImageComponentHelper } from '../StoryblokImageComponentHelper'

import styles from './StoryblokImageCard.module.css'

export const StoryblokImageCard: FC<
  StoryblokComponentProps<StoryblokImageCardType>
> = ({ blok }) => {
  return (
    <Link
      {...storyblokEditable(blok)}
      className="flex shrink-0 grow-0 cursor-pointer snap-start flex-col overflow-x-hidden text-dark-primary-max no-underline"
      data-carousel-item
      href={getStoryblokHrefLink(blok.link)}
    >
      <div
        className={clsx(
          styles['image-card-container'],
          blok.size === 'small' && styles['image-card-container--small'],
          blok.size === 'medium' && styles['image-card-container--medium'],
          blok.size === 'large' && styles['image-card-container--large'],
          blok.backgroundColor === 'now' && 'bg-light-brand-low',
          blok.backgroundColor === 'white' && 'bg-light-primary-low',
          blok.backgroundColor === 'light' && 'bg-light-primary-medium',
          blok.addBorders && styles['image-card-container--borders'],
        )}
      >
        <StoryblokImageComponentHelper
          className={clsx(
            'size-full rounded-2xl',
            blok.expandImage ? 'object-cover' : 'object-contain p-6',
          )}
          fill
          image={blok.image}
        />
      </div>
      {blok.title ? (
        <span className="mt-2 text-center text-s font-medium">
          {blok.title}
        </span>
      ) : null}
      {blok.clickToAction ? (
        <div className="mt-1.5 flex items-center font-medium">
          <span>{blok.clickToAction}</span>
          <IconArrowRight className="size-6" />
        </div>
      ) : null}
    </Link>
  )
}
